
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return require("private-next-pages/app/core/pages/_app.tsx");
      }
    ]);
  